import { IconMapBus16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from '../../types';

interface IGeoTravelTimeProps {
  transportType: ETransportType;
  time: string;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, time }) => {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapBus16;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <UIText2 display="inline" color="gray60_100">
        {time}
      </UIText2>
    </div>
  );
};
